import React from 'react'
import { View } from 'react-native'
import { Formik, FormikHelpers } from 'formik'
import tw from 'tailwind-rn'
import { LoginFormValidationSchema } from './validationSchema'

import { HGTextInput } from '../../components/Form'
import { HGButton } from '../../components/HGUI'

// import styles from './styles'

export type Credentials = {
  username: string
  password: string
}

const initialValues: Credentials = {
  username: '',
  password: '',
}

type Props = {
  onSubmit: (
    credentials: Credentials,
    setSubmitting: (value: boolean) => void
  ) => void
}

const LoginForm = (props: Props) => {
  const { onSubmit } = props

  return (
    <Formik
      initialValues={initialValues}
      validationSchema={LoginFormValidationSchema}
      onSubmit={(
        { username, password }: Credentials,
        { setSubmitting }: FormikHelpers<Credentials>
      ) => {
        // console.log(values)
        onSubmit({ username, password }, setSubmitting)
      }}
      validateOnMount
    >
      {({
        handleChange,
        handleBlur,
        handleSubmit,
        isSubmitting,
        isValid,
        values,
      }) => (
        <View>
          <View>
            <HGTextInput
              onChangeText={handleChange('username')}
              onBlur={handleBlur('username')}
              value={values.username}
              autoCapitalize="none"
              placeholder="E-Mail-Adresse …"
              keyboardType="email-address"
              textContentType="username"
              style={tw('mb-4')}
              autoCorrect={false}
            />
          </View>

          <View>
            <HGTextInput
              onChangeText={handleChange('password')}
              onBlur={handleBlur('password')}
              value={values.password}
              placeholder="Password …"
              textContentType="password"
              secureTextEntry
              onSubmitEditing={() => handleSubmit()}
            />
          </View>

          <HGButton
            disabled={isSubmitting || !isValid}
            title={!isSubmitting ? 'Anmelden' : 'Wird angemeldet …'}
            onPress={handleSubmit}
            style={tw('mt-6')}
          />
        </View>
      )}
    </Formik>
  )
}

export default LoginForm
